// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"90571735","566":"0f7ae6b2"}[chunkId] + ".chunk.js";
};